import {
  useMutationClubUpdateCommunicationProperties,
  useQueryClubGetCommunicationProperties,
} from "@gymflow/api";
import { ModalContext } from "apps/portal/src/providers";
import useGymflowModels from "apps/portal/src/store";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { ApiResolverContext } from "../../../providers/ApiResolverProvider/ApiResolverContext";
import { AlertTriangleIcon, Spinner, Switch, WarningBlock } from "../../atoms";
import { ConfirmModal } from "../../templates";

export const MarketingForm = () => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();
  const { clubId } = useContext(ApiResolverContext);
  const { setModal, hide } = useContext(ModalContext);

  const {
    data: dataClubCommunicationProperties,
    isLoading: isLoadingClubCommunicationProperties,
  } = useQueryClubGetCommunicationProperties({ api, clubId });

  const { mutateAsync: mutateAsyncUpdateCommunicationProperties } =
    useMutationClubUpdateCommunicationProperties({ api, clubId });

  // Temporary solution
  // Answer: https://linear.app/gymflow/issue/GYM-1913/allow-for-value-to-set-default-marketing-opt-ins#comment-adaf304c
  const isCommunication = !!(
    dataClubCommunicationProperties?.defaultEmailCommunication ||
    dataClubCommunicationProperties?.defaultSmsCommunication
  );

  return (
    <div className="flex w-full flex-col gap-y-4 p-6">
      <div className="flex flex-row justify-between gap-4">
        <div className="flex flex-col gap-1">
          <div className="text-base font-semibold text-gray-950">
            {t("page.settings.tab.club.clubInfo.marketingForm.title")}
          </div>
          <div className="text-sm font-medium text-gray-500">
            {t("page.settings.tab.club.clubInfo.marketingForm.description")}
          </div>
        </div>
        {isLoadingClubCommunicationProperties ? (
          <Spinner />
        ) : (
          <Switch
            value={isCommunication}
            onChange={async () => {
              if (isCommunication) {
                await mutateAsyncUpdateCommunicationProperties({
                  defaultEmailCommunication: !isCommunication,
                  defaultSmsCommunication: !isCommunication,
                });
              } else {
                setModal(
                  <ConfirmModal
                    type="warning"
                    title={t(
                      "page.settings.tab.club.clubInfo.marketingForm.modals.confirmEnabling.title",
                    )}
                    icon={<AlertTriangleIcon className="size-6" />}
                    onCancel={() => hide()}
                    onConfirm={async () => {
                      await mutateAsyncUpdateCommunicationProperties({
                        defaultEmailCommunication: !isCommunication,
                        defaultSmsCommunication: !isCommunication,
                      });

                      hide();
                    }}
                  >
                    <div className="flex flex-col gap-4">
                      {t(
                        "page.settings.tab.club.clubInfo.marketingForm.modals.confirmEnabling.description",
                      )}
                      <WarningBlock
                        text={t(
                          "page.settings.tab.club.clubInfo.marketingForm.modals.confirmEnabling.warningBlock",
                        )}
                      />
                    </div>
                  </ConfirmModal>,
                );
              }
            }}
          />
        )}
      </div>
      <WarningBlock
        text={t("page.settings.tab.club.clubInfo.marketingForm.warningBlock")}
      />
    </div>
  );
};
